import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-attribute-picker',
  templateUrl: './attribute-picker.component.html',
  styleUrls: ['./attribute-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttributePickerComponent implements OnInit {

  @Input() attributeList: any;
  @Output() attributeSelected: EventEmitter<any> = new EventEmitter();
  selectedValue = null;

  constructor() {
  }

  ngOnInit(): void {
  }

  onOptionSelected(option: any): void {
    const selectedValue = { ...option, dismissable: true };
    this.attributeSelected.emit(selectedValue);
  }
}
